import React, { useState, useEffect, useRef } from 'react'
import { HeaderReimburse } from '../../../components/Header/HeaderReimburse'
import axios from 'axios'
import { Baseurl } from '../../../../Config/Baseurl'
import { useNavigate, useParams, Link } from 'react-router-dom'
import { GiCancel } from 'react-icons/gi'
import { BsCheck2Circle } from 'react-icons/bs'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

export const EditReimburse = () => {
  toast.configure()
  const inputRef = useRef(null)
  const navigate = useNavigate()
  const email = localStorage.getItem('email')
  const params = useParams()
  const [mode, setMode] = useState([])
  const [data, setData] = useState()
  const [file, setFile] = useState(null)
  const [errMsg, setErrMsg] = useState('')
  const [successMsg, setSuccessMsg] = useState('')

  const getMode = async () => {
    await axios
      .get(Baseurl.nodeLocal + 'dropdown/getAllPaymentMode')
      .then((res) => {
        setMode(res.data.data)
      })
      .catch((err) => {})
  }

  const getData = async () => {
    await axios
      .post(Baseurl.nodeLocal + 'request/updateRequest', { id: params.id })
      .then((res) => {
        setData(res.data.data[0])
      })
      .catch((err) => {})
  }

  let name, value
  const handleChange = (e) => {
    name = e.target.name
    value = e.target.value

    setData({ ...data, [name]: value })
  }

  const resetFileInput = () => {
    inputRef.current.value = null
    setErrMsg('')
    setSuccessMsg('')
  }

  const handleFile = (file) => {
    setErrMsg('')
    setSuccessMsg('')
    setFile(file)
    if (
      file.type === 'image/png' ||
      file.type === 'image/jpeg' ||
      file.type === 'image/jpg' ||
      file.type === 'application/pdf'
    ) {
      setSuccessMsg('File uploded Successfully!')
    } else {
      setErrMsg('Failed to upload file; the format is not supported!')
    }
    if (file.size > 5000000) {
      setErrMsg('File is too large ! Maximum file size is 5 MB.')
    }
  }

  useEffect(() => {
    getData()
    getMode()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const submitRequest = async (e) => {
    e.preventDefault()
    const formData = new FormData()

    const bodydata = {
      resubmit: true,
      id: params.id,
      email: email,
      payee_name: data.payee_name,
      dept_name: data.dept_name,
      desig_id: data.desig_id,
      manager_name: data.manager_name,
      paid_amount: parseFloat(data.paid_amount),
      mode_id: data.mode_id,
      purpose_of_expenditure: data.purpose_of_expenditure,
      date_of_expense: data.date_of_expense,
      expenditure_category: data.expenditure_category,
      invoice: data.invoice,
    }

    formData.append('data', JSON.stringify(bodydata))
    formData.append('invoice', file)
    await axios
      .post(Baseurl.nodeLocal + 'request/initiateNewRequest', formData)
      .then((res) => {
        toast.success(res.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        })
        setTimeout(() => {
          navigate('/view-reimburse')
        }, 2000)
        resetFileInput()
      })
      .catch((err) => {})
  }
  return (
    <div className="container p-3 d-flex align-items-center justify-content-center flex-column">
      <HeaderReimburse />
      <div className="mt-4 w-100 d-flex justify-content-start">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/add-reimburse" className="link text-primary">
                Home
              </Link>
            </li>
            <li className="breadcrumb-item" aria-current="page">
              <Link to="/view-reimburse" className="link text-primary">
                My Requests
              </Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Edit Request
            </li>
          </ol>
        </nav>
      </div>
      <h5 className="mb-4 mx-2 mt-3 text-primary text-start w-100">
        Edit Request
      </h5>

      {data ? (
        <div className="card p-5 w-100">
          <form onSubmit={submitRequest}>
            <div className="row">
              <h6 className="m-b-20 p-b-5 b-b-default f-w-600 w-100">
                Employee Details
              </h6>
              <div className="row">
                <div className="col-md">
                  <div className="mb-3 row">
                    <h6 className="col-sm-4 col-form-label text-muted">Name</h6>
                    <div className="col-sm-8">
                      <input
                        type="text"
                        className="form-control"
                        name="payee_name"
                        defaultValue={data.payee_name}
                        readOnly
                      />
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <h6 className="col-sm-4 col-form-label text-muted">
                      Employee ID
                    </h6>
                    <div className="col-sm-8">
                      <input
                        type="text"
                        className="form-control"
                        name="desig_id"
                        defaultValue={data.desig_id}
                        readOnly
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md">
                  <div className="mb-3 row">
                    <h6 className="col-sm-4 col-form-label text-muted">
                      Department
                    </h6>
                    <div className="col-sm-8">
                      <input
                        type="text"
                        className="form-control"
                        name="dept_name"
                        defaultValue={data.dept_name}
                        readOnly
                      />
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <h6 className="col-sm-4 col-form-label text-muted">
                      Manager
                    </h6>
                    <div className="col-sm-8">
                      <input
                        type="text"
                        className="form-control"
                        name="manager_name"
                        defaultValue={data.manager_name}
                        readOnly
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <h6 className="m-b-20 p-b-5 b-b-default f-w-600 w-100 mt-3">
                Expense Details
              </h6>
              <div className="col-md">
                <div className="mb-3 row">
                  <h6 className="col-sm-4 col-form-label text-muted">
                    Expense Date
                  </h6>
                  <div className="col-sm-8">
                    <input
                      type="date"
                      class="form-control"
                      max={new Date().toISOString().split('T')[0]}
                      name="date_of_expense"
                      defaultValue={data.date_of_expense}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>
                {mode.length > 0 ? (
                  <div className="mb-3 row">
                    <h6 className="col-sm-4 col-form-label text-muted">
                      Payment Method
                    </h6>
                    <div className="col-sm-8">
                      <select
                        className="form-select"
                        aria-label="Default select example"
                        name="mode_id"
                        defaultValue={data.mode_id}
                        onChange={handleChange}
                        required
                      >
                        <option selected disabled value="Select">
                          Select
                        </option>
                        {mode?.map((i, index) => {
                          return (
                            <option value={i.mode_id} key={index}>
                              {i.mode_name}
                            </option>
                          )
                        })}
                      </select>{' '}
                    </div>
                  </div>
                ) : (
                  ''
                )}
                <div className="mb-3 row">
                  <h6 className="col-sm-4 col-form-label text-muted">
                    Description
                  </h6>
                  <div className="col-sm-8">
                    <textarea
                      type="text"
                      class="form-control"
                      name="purpose_of_expenditure"
                      defaultValue={data.purpose_of_expenditure}
                      onChange={handleChange}
                      maxLength={400}
                    />
                    <h6
                      className="text-muted mt-2"
                      style={{ fontSize: '12px' }}
                    >
                      Please give detailed reasons for all expenditures. Maximum
                      400 characters.
                    </h6>
                  </div>
                </div>
              </div>

              <div className="col-md">
                <div className="mb-3 row">
                  <h6 className="col-sm-4 col-form-label text-muted">Amount</h6>
                  <div className="col-sm-8">
                    <input
                      type="number"
                      class="form-control"
                      step="0.01"
                      min="0"
                      max="100000"
                      name="paid_amount"
                      defaultValue={data.paid_amount}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>
                <div className="mb-3 row">
                  <h6 className="col-sm-4 col-form-label text-muted">
                    Category
                  </h6>
                  <div className="col-sm-8">
                    <select
                      className="form-select"
                      aria-label="Default select example"
                      name="expenditure_category"
                      defaultValue={data.expenditure_category}
                      onChange={handleChange}
                      required
                    >
                      <option selected disabled value="">
                        Select
                      </option>
                      <option value="Business Cards">Business Cards</option>
                      <option value="Business Meals">Business Meals</option>
                      <option value="Dues">Dues</option>
                      <option value="Legal Fees">Legal Fees</option>
                      <option value="License Fees">License Fees</option>
                      <option value="Mileage">Mileage</option>
                      <option value="Office Supplies">Office Supplies</option>
                      <option value="Passport fee">Passport fee</option>
                      <option value="Postage">Postage</option>
                      <option value="Printer Cartridges">
                        Printer Cartridges
                      </option>
                      <option value="Printer Paper">Printer Paper</option>
                      <option value="Software">Software</option>
                      <option value="Stationery">Stationery</option>
                      <option value="Subscriptions">Subscriptions</option>
                      <option value="Telephones">Telephones</option>
                      <option value="Tools">Tools</option>
                      <option value="Training Fees">Training Fees</option>
                      <option value="Travel">Travel</option>
                      <option value="Work Clothing">Work Clothing</option>
                      <option value="Gift">Gift</option>
                      <option value="Miscellaneous office expense">
                        Miscellaneous office expense
                      </option>
                      <option value="Other">Other</option>
                    </select>
                  </div>
                </div>

                <div className="mb-3 row">
                  <h6 className="col-sm-4 col-form-label text-muted">
                    Current Invoice
                  </h6>
                  <div className="col-sm-8">
                    <input
                      type="text"
                      className="form-control mb-1"
                      name="invoice"
                      value={data.invoice}
                    />
                  </div>
                </div>
                <div className="mb-3 row">
                  <h6 className="col-sm-4 col-form-label text-muted">
                    New Invoice
                  </h6>
                  <div className="col-sm-8">
                    <input
                      type="file"
                      className="form-control mb-1"
                      name="invoice"
                      onChange={(e) => {
                        handleFile(e.target.files[0])
                      }}
                      ref={inputRef}
                    />
                    <h6 className="text-muted" style={{ fontSize: '12px' }}>
                      .png, .jpg, .pdf file only. Maximum file size is 5 MB.
                    </h6>

                    {errMsg ? (
                      <div className="d-flex">
                        <h6 className="text-danger mx-1">{errMsg}</h6>
                        <GiCancel style={{ color: '#dc3545' }} />
                      </div>
                    ) : successMsg ? (
                      <div className="d-flex">
                        <h6 className="text-success mx-1">{successMsg}</h6>
                        <BsCheck2Circle style={{ color: '#198754' }} />
                      </div>
                    ) : (
                      ''
                    )}
                  </div>
                </div>
              </div>

              <div className="d-flex justify-content-end">
                <button
                  className={
                    errMsg ||
                    data.final_status === 'Rejected' ||
                    data.status === 'Rejected'
                      ? 'btn btn-primary disabled me-md-2'
                      : 'btn btn-primary me-md-2'
                  }
                  type="submit"
                >
                  Submit Request
                </button>
              </div>
            </div>
          </form>
        </div>
      ) : (
        <h6>Something went wrong!</h6>
      )}
    </div>
  )
}
